import {
    Badge,
    BlockStack,
    Box,
    Button,
    Card,
    Grid,
    InlineStack,
    Link,
    Page,
    Text,
    TextField,
    Thumbnail,
  } from "@shopify/polaris";
  import { useNavigate, useLocation } from "react-router-dom";
  import { useState, useEffect, useCallback } from "react";
  import { useTrackOrderSearchMutation } from "../../store/store/slices/OrderRTK";
  
  const PostBookingPage = () => {
    const navigateTo = useNavigate();
    const location = useLocation();
    const params = new URLSearchParams(location.search);
    const orderNameFromQuery = params.get("orderName");
    const [theme, setTheme] = useState(localStorage.getItem("theme") || "light");
    const [trackOrder, { isLoading }] = useTrackOrderSearchMutation();
    const [trackingInput, setTrackingInput] = useState(orderNameFromQuery || "");
    const [orderData, setOrderData] = useState<any>(null);
    const [errorMessage, setErrorMessage] = useState<string>("");

    const handleTrackingSearchWithValue = useCallback(async (value: string) => {
      if (!value.trim()) return;

      setOrderData(null);
      setErrorMessage("");

      try {
        const response = await trackOrder({ order_name: value }).unwrap();
        if (response?.order) {
          setOrderData(response.order);
        } else {
          setErrorMessage("No order found for this order number.");
        }
      } catch (err: any) {
        setErrorMessage(err?.data?.message || "Failed to fetch order.");
      }
    }, [trackOrder]);

    // Auto-search if orderName is provided in query params
    useEffect(() => {
      if (orderNameFromQuery && orderNameFromQuery.trim()) {
        setTrackingInput(orderNameFromQuery);
        // Trigger search automatically
        handleTrackingSearchWithValue(orderNameFromQuery);
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [orderNameFromQuery]);
  
    const handleTrackingSearch = async () => {
      if (!trackingInput.trim()) return;
  
      setOrderData(null);
      setErrorMessage("");
  
      try {
        const response = await trackOrder({  order_name: trackingInput }).unwrap();
        if (response?.order) {
          setOrderData(response.order);
        } else {
          setErrorMessage("No order found for this order number.");
        }
      } catch (err: any) {
        setErrorMessage(err?.data?.message || "Failed to fetch order.");
      }
    };
  
    const renderContent = () => {
      if (isLoading) {
        return (
          <>

          </>
        );
      }
  
      if (errorMessage) {
        return (
          <Grid columns={{ xs: 1, md: 2 }}>
          <Grid.Cell columnSpan={{ md: 6, lg: 8 }}>
            

           <Card >
          
              <Text as="h1" fontWeight="medium" tone="base">
                {errorMessage}
              </Text>
           
          </Card>
            </Grid.Cell></Grid>
        
        );
      }
  
      if (!orderData) {
        return (
          <>
           
          </>
        );
      }
  
      const dataToShow = orderData;
      return (
        <Grid columns={{ xs: 1, md: 2 }}>
          <Grid.Cell columnSpan={{ md: 6, lg: 8 }}>
            <BlockStack gap="400">
              <Card>
                <BlockStack gap="200">
                  <Text as="h1" fontWeight="medium">
                    Items detail
                  </Text>
                  {dataToShow?.items?.map((product, index) => (
                    <Box
                      key={index}
                      borderRadius="200"
                      borderWidth="025"
                      borderColor="border-disabled"
                      paddingInline="300"
                      paddingBlock="300"
                      background="bg-fill"
                    >
                      <div style={{ display: "flex", gap: "1rem" }}>
                        <Thumbnail
                          size="small"
                          source={product?.image}
                          alt="product image"
                        />
                        <div style={{ width: "100%" }}>
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              paddingBottom: "3px",
                            }}
                          >
                            <BlockStack gap="100">
                              <Text variant="bodyMd" fontWeight="medium" as="span">
                                {product?.title}
                              </Text>
                            </BlockStack>
                            <Text as="span" variant="bodyMd">
                              Rs.{product?.price}
                            </Text>
                          </div>
                          <Text as="span" variant="bodyMd">
                            Qty: {product?.quantity}
                          </Text>
                        </div>
                      </div>
                    </Box>
                  ))}
                </BlockStack>
              </Card>
            </BlockStack>
          </Grid.Cell>
  
          <Grid.Cell columnSpan={{ md: 4, lg: 4 }}>
            <BlockStack gap="400">
            <Card>
                <BlockStack gap="300">
                  <Text as="h1" fontWeight="medium">
                    Consignee details
                  </Text>
                  <BlockStack gap="100">
                    <p>{dataToShow?.consignee?.name}</p>
                    {/* <p>{dataToShow?.consignee?.email}</p>
                    <p>{dataToShow?.consignee?.phone}</p>
                    <p>{dataToShow?.consignee?.address}</p>
                    <p>{dataToShow?.consignee?.city}</p> */}
                  </BlockStack>
                </BlockStack>
              </Card>
              <Card>
                <BlockStack gap="300">
                  <Text as="h1" fontWeight="medium">
                    Booking details
                  </Text>
                  <BlockStack gap="100">
                    <p>
                      <b>Order ID:</b> {dataToShow?.order_name}
                    </p>
                    {/* <p>
                      <b>Booked by:</b> {dataToShow?.booked_by?.first_name + " " + dataToShow?.booked_by?.last_name}
                    </p> */}
                    <p>
                      <b>Status:</b>{" "}
                      <Badge tone={dataToShow?.booked_packet_status === "FULFILLED" ? "success" : "magic"}>{dataToShow?.booked_packet_status}</Badge>
                    </p>
                    <p>
                      <b>Courier:</b> {dataToShow?.tracking_details?.company}
                    </p>
                    <p>
                       {dataToShow?.tracking_details?.tracking_url &&  <InlineStack gap="100"><b>Tracking #:</b> 
                    <Link url={dataToShow?.tracking_details?.tracking_url || ""}>
                      <span style={{color: theme ===  "dark" ? "white" : "unset" }}>{dataToShow?.tracking_details?.tracking_number || "Track this order"}</span>
                    </Link>
                  </InlineStack>}
                    </p>
                  </BlockStack>
                </BlockStack>
              </Card>
            
              
  
             
  
              
  
              <Card>
                <BlockStack gap="200">
                  <Text as="h2" fontWeight="semibold" variant="headingSm">
                    Payment
                  </Text>
                  <div style={{ display: "flex", justifyContent: "space-between" }}>
                    <Text as="span" variant="bodyMd">
                      {dataToShow?.payment?.method} amount
                    </Text>
                    <Text as="span" variant="headingSm">
                      Rs.{Number(dataToShow?.payment?.amount || 0).toFixed(2)}
                    </Text>
                  </div>
                </BlockStack>
              </Card>


            </BlockStack>
          </Grid.Cell>
        </Grid>
      );
    };
  
    return (
      <Page
        title={orderData?.order_name || "Track Order"}
        titleMetadata={
          orderData ? <Badge tone={orderData?.booked_packet_status === "FULFILLED" ? "success" : "magic"}>{orderData?.booked_packet_status}</Badge> : <></>
        }
      
        backAction={{ onAction: () => navigateTo(-1) }}
      >
        <BlockStack gap="400">
          {/* Tracking Control */}
          

          <Grid columns={{ xs: 1, md: 2 }}>
          <Grid.Cell columnSpan={{ md: 6, lg: 8 }}>
          <Card>
            <InlineStack gap="300" align="space-between" blockAlign="center">
              <div style={{ width: "100%"}}>

                <TextField
                  label="Tracking number"
                  labelHidden
                  value={trackingInput}
                  onChange={setTrackingInput}
                  placeholder="Enter shopify order name i.e #1013"
                  autoComplete="off"
                  connectedRight={  <Button loading={isLoading} variant={theme === "dark" ? "secondary" : "primary"} onClick={handleTrackingSearch}>
                  Track
                </Button>}
                  />
                  </div>
              
            
            </InlineStack>
          </Card>
          </Grid.Cell>
          </Grid>
  
          {/* Dynamic Content */}
          {renderContent()}
        </BlockStack>
      </Page>
    );
  };
  
  export default PostBookingPage;
  